import {
  Fieldset,
  FieldsetLegend,
} from "@imi/ui/components/Fieldset/Fieldset.js";
import { UnitsOptions } from "@src/core/engine/units/unitsRepository";
import { useTranslation } from "react-i18next";
import { useUnitsForm } from "../hooks/useUnitsForm";

type PressureAndFlowProps = {
  form: ReturnType<typeof useUnitsForm>["form"];
  unitsOptions: UnitsOptions;
};

export function PressureAndFlow({ form, unitsOptions }: PressureAndFlowProps) {
  const { t } = useTranslation("settings", { keyPrefix: "units" });

  return (
    <Fieldset>
      <FieldsetLegend>{t("pressureAndFlow.title")}</FieldsetLegend>
      <form.AppField name="kvCvCoefficient">
        {(field) => (
          <field.Select
            autoFocus
            label={t("pressureAndFlow.fields.kvCvCoefficient")}
          >
            {unitsOptions.kvCvCoefficient.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="differentialPressure">
        {(field) => (
          <field.Select
            label={t("pressureAndFlow.fields.differentialPressure")}
          >
            {unitsOptions.differentialPressure.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="staticPressure">
        {(field) => (
          <field.Select label={t("pressureAndFlow.fields.staticPressure")}>
            {unitsOptions.staticPressure.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="linearPressureDrop">
        {(field) => (
          <field.Select label={t("pressureAndFlow.fields.linearPressureDrop")}>
            {unitsOptions.linearPressureDrop.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="flow">
        {(field) => (
          <field.Select label={t("pressureAndFlow.fields.flow")}>
            {unitsOptions.flow.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="velocity">
        {(field) => (
          <field.Select label={t("pressureAndFlow.fields.velocity")}>
            {unitsOptions.velocity.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>
    </Fieldset>
  );
}
